module.exports = __webpack_public_path__ + "static/media/hausdao__logo.9ca25dfb.png";